const reward = {
  share: {
    dac: 1.5, // 1.5
    charity: 1, // 1
    services: 0.5, // 0.5
    referral: 0.5, // 0.5
    otherTotal: 3,
    user: 0
  },
  calcShare: function (p) {
    const s = this.share
    s.user = p - this.share.otherTotal
    this.share = s
    return s
  },
  percentage: {
    dac: 0,
    charity: 0,
    services: 0,
    user: 0
  },
  userpercentage: function (p) {
    return p / 2
  },
  dacpercentage: function (p) {
    return this.share.dac
  },
  charityPercentage: function (p) {
    return this.share.charity
  },
  servicesPercentage: function (p) {
    return this.share.services
  },
  calcPercentage: function (p) {
    const percentage = this.percentage
    const s = this.share
    percentage.dac = s.dac / p
    percentage.charity = s.charity / p
    percentage.services = s.services / p
    percentage.user = 100 - ((percentage.dac * 100) + (percentage.charity * 100) + (percentage.services * 100))
    this.percentage = percentage
    return percentage
  },
  calc: function (p, reward) {
    const percentage = this.percentage
    const r = {
      dac: 0,
      charity: 0,
      services: 0,
      user: 0,
      referral: 0
    }
    r.dac = percentage.dac * reward * 0.01
    r.charity = percentage.charity * reward * 0.01
    r.services = percentage.services * reward * 0.01
    r.user = percentage.user * reward * 0.01
    r.referral = percentage.user * reward * 0.01 * 0.5
    return r
  },
  totalReward: function (salary, percentage) {
    return salary * percentage * 0.01
  },
  referReward: function (reward, percentage) {
    return this.calc(percentage, reward).referral
  },
  user: function (salary, percentage) {
    return this.calc(percentage, salary).user
  },
  dac: function (salary, percentage) {
    return this.calc(percentage, salary).dac
  },
  charity: function (salary, percentage) {
    return this.calc(percentage, salary).charity
  }
}

export default reward



// WEBPACK FOOTER //
// ./src/helpers/reward.js